import { render } from "./HistoryTab.vue?vue&type=template&id=175f47f5&scoped=true"
import script from "./HistoryTab.vue?vue&type=script&lang=js"
export * from "./HistoryTab.vue?vue&type=script&lang=js"

import "./HistoryTab.vue?vue&type=style&index=0&id=175f47f5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175f47f5"]])

export default __exports__